module.exports = __webpack_public_path__ + "static/media/waitlist-member-7.5ec271de.jpeg";